// A pipeline needs its own class/day, not the history of every traffic assessment.
export function pipelineDate(classId, classes = []) {
  const saved = classes.find(row => row.id === classId);
  const value = saved?.scheduledDateKey || saved?.classDate || saved?.scheduledDate?.slice(0, 10)
    || String(classId || '').match(/(?:^|[-_])(\d{4}-\d{2}-\d{2})(?:[-_]|$)/)?.[1] || '';
  return /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(value))
    && new Date(value).toISOString().slice(0, 10) === value ? value : '';
}

export function pipelineReadFilters(classId, date, { flows = false } = {}) {
  const filters = [[['classId', '==', classId]]];
  if (!date) return filters;
  filters.push([[flows ? 'courseDate' : 'classDate', '==', date]]);
  if (!flows) {
    // Legacy rows lack classDate. Cover both Melbourne offsets, independently of
    // the browser's timezone; class grouping removes rows outside the selected day.
    const midnight = Date.parse(`${date}T00:00:00Z`) / 1000;
    filters.push([['Created', '>=', midnight - 11 * 3600], ['Created', '<', midnight + 14 * 3600]]);
    filters.push([['data.classId', '==', classId]]);
  }
  return filters;
}

export function mergePipelineSnapshots(snapshots) {
  return [...new Map(snapshots.flatMap(snapshot => snapshot.docs || []).map(doc => [doc.id, doc])).values()];
}
